import React from 'react';

export const ButtonIcon = ({ icon }) => {
  if (icon === 'download') {
    return (
      <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_1147_986)">
          <path
            d="M16.0079 8.88118C16.3543 8.59478 16.854 8.84309 16.9328 9.29401C17.0681 10.0618 16.9937 12.5251 16.7811 13.2761C16.3662 14.7355 14.9745 15.8232 13.5084 15.9192C10.0483 16.1461 6.24921 15.8186 2.77725 15.8201C1.62786 15.4256 0.561731 14.504 0.222712 13.2761C-0.000326079 12.4733 -0.0568292 10.1958 0.0576639 9.35952C0.163236 8.58869 1.07175 8.64962 1.16096 9.12644C1.15501 11.2927 0.69258 14.5634 3.64264 14.7812C6.80532 15.0158 10.2401 14.5969 13.4325 14.7812C16.5863 14.2831 15.5707 11.4435 15.8354 9.27421C15.8488 9.15843 15.9246 8.95125 16.0079 8.8827V8.88118Z"
            fill="white"
          />
          <path
            d="M9.01894 9.84546L9.28212 9.77386L12.4478 6.64028C13.157 6.46205 13.4455 6.9998 13.0217 7.6061C12.3883 8.51251 10.314 10.4563 9.42784 11.2896C8.47026 12.1915 8.52974 12.1915 7.57216 11.2896C6.67257 10.4426 4.63103 8.52927 3.97827 7.6061C3.76564 7.30447 3.65263 6.90992 4.02287 6.66618C4.37081 6.43615 4.6221 6.68751 4.8838 6.89011C5.71499 7.53603 6.738 8.79281 7.54094 9.57735C7.7045 9.7373 7.64651 9.92468 7.98107 9.84546V0.245156C7.98107 -0.0823697 9.01894 -0.0823697 9.01894 0.245156V9.84394V9.84546Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_1147_986">
            <rect width="17" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }
  if (icon === 'add') {
    return (
      <svg
        width="8"
        height="8"
        viewBox="0 0 8 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.632 7.664L3.632 0.448H4.976L4.976 7.664H3.632ZM0.912 4.72L0.912 3.408L7.696 3.408V4.72L0.912 4.72Z"
          fill="white"
        />
      </svg>
    );
  }
  return false;
};
